import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute'
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import VotingPage from './pages/VotingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import PendingRestoApprovalPage from './pages/PendingRestoApprovalPage';
import OnboardingPage from './pages/OnboardingPage';
import LegalDocumentPage from './pages/LegalDocumentPage';
import RootPage from './pages/RootPage';
import MainPage from './pages/MainPage';

const App = () => {
	// Los errores globales ahora se manejan en logger.js
	// El logger se inicializa automáticamente y captura errores

	return (
		<BrowserRouter>
			<ToastProvider>
				<AuthProvider>
					<Switch>
						<Route exact path="/login" component={LoginPage}></Route>
						<Route exact path="/signup/:id" component={SignupPage}></Route>
						<Route exact path="/onbording" component={OnboardingPage}></Route>
						<Route exact path="/resto-pending-approval" component={PendingRestoApprovalPage}></Route>
						<Route exact path="/legal/:slug" component={LegalDocumentPage}></Route>
						<Route exact path="/w/:id" component={VotingPage}></Route>
						<ProtectedRoute exact path="/almacen/trivias/marketplace" component={MainPage} />
						<Route exact path="/" component={RootPage}></Route>
					</Switch>
				</AuthProvider>
			</ToastProvider>
		</BrowserRouter>
	);
}

export default App;
